import { render, staticRenderFns } from "./LandingPortailClient.vue?vue&type=template&id=aa9e9aa6&scoped=true"
import script from "./LandingPortailClient.vue?vue&type=script&lang=js"
export * from "./LandingPortailClient.vue?vue&type=script&lang=js"
import style0 from "./LandingPortailClient.vue?vue&type=style&index=0&id=aa9e9aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9e9aa6",
  null
  
)

export default component.exports